import React, { useState, useEffect } from 'react';

/**
 * Illustration intercalée dans le fil d'un article.
 *
 * Contrairement à `ArticleCover`, aucun repli visuel : le dégradé surmonté du
 * pictogramme de catégorie a du sens pour une couverture absente, pas au milieu
 * d'un texte. Une image qui ne charge pas disparaît donc, et le fil de lecture se
 * referme sur lui-même.
 */
const ArticleImage = ({ url, legende }) => {
  const [failed, setFailed] = useState(false);

  // Le même composant peut être réutilisé pour une autre image lors d'une
  // navigation entre articles : on réarme le masquage quand l'URL change.
  useEffect(() => { setFailed(false); }, [url]);

  if (!url || failed) return null;

  return (
    <figure className="article-page__figure">
      <img
        className="article-page__figure-img"
        src={url}
        alt={legende || ''}
        loading="lazy"
        decoding="async"
        onError={() => setFailed(true)}
      />
      {legende && <figcaption className="article-page__figure-caption">{legende}</figcaption>}
    </figure>
  );
};

export default ArticleImage;
